import React from 'react';
import resume from '../assets/resume.pdf';
import '../style/About.css';

function About() {
  return (
    <div className="about-container">
      <h2>About Me</h2>
      <p className="about-text">
        Hi there, I'm Jin! <br/>

        I'm a senior at Columbia studying computer science. 
        </p>
      <div className="about-resume">
        <h2 style={{ textalign: "center" }} >Resume</h2>
        <iframe src={resume} width="100%" height="1000px"></iframe>
      </div>
    </div>
  );
}

export default About;
